import LoadingButton from '@/common/components/base/button/loadingButton';
import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import SignatureDrawingPad from '@/common/components/base/signatureCanvas/instances/SignatureDrawingPad';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import useSignature from '@/common/hooks/useSignature';
import { ConvertUrlToFile } from '@/common/utils/ConvertUrlToFile';
import useSignatureRegisterMutation from '@/modules/Dashboard/hooks/useSignatureRegisterMutation';
import { SignatureModalType } from '@/modules/FileDetail/components/action/actionList/modals/SignatureModal/SignatureModal.types';
import { Box } from 'styled-system/jsx';

export default ({ open, closeModal }: MainModalProps) => (
  <MainModal open={open} closeModal={closeModal}>
    <SignatureModal closeModal={closeModal} />
  </MainModal>
);

const SignatureModal = ({ closeModal }: SignatureModalType) => {
  const signature = useSignature();
  const { mutate, isPending } = useSignatureRegisterMutation();

  const generateFormData = (blob: Blob) => {
    const formData = new FormData();
    const image = ConvertUrlToFile(blob, 'image', 'image');

    formData.append('image', image);
    return formData;
  };

  const submitSignature = async () => {
    const signBlob = await signature.getImage();
    const formData = generateFormData(signBlob);
    mutate(formData as any, {
      onSuccess: () => closeModal(),
    });
  };

  return (
    <>
      <TitleDescription>ثبت امضا</TitleDescription>
      <Typography my="24px" textStyle="b2">
        کارشناس عزیز ؛ امضای خود را پیش از ارسال پرونده ثبت نمایید.
      </Typography>
      <Typography mb="5px" textStyle="b4" color="black-2">
        ثبت امضا :
      </Typography>
      <Box mb="40px">
        <SignatureDrawingPad {...signature} />
      </Box>
      <LoadingButton
        onClick={submitSignature}
        disabled={signature.isEmpty}
        loading={isPending}
        fullWidth
      >
        ثبت
      </LoadingButton>
    </>
  );
};
